// @flow

import NestedResource from 'speed-js-core/src/api/NestedResource';

export default class PriceListItemResource extends NestedResource {
    basePath: string = 'billing/price-list/{parent}/item/';

    objectPath: string = 'billing/price-list/{parent}/item/{ident}/';
}
